import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Upload, Database, Table, Zap, BarChart3 } from 'lucide-react';

export default function Navigation() {
    const location = useLocation();
    const navItems = [
        { name: "Dashboard", path: "/", icon: BarChart3 },
        { name: "Extraction Dossier", path: "/upload", icon: Upload },
        { name: "Liste des Dossiers", path: "/records", icon: Database },
    ];

    return (
        <nav className="bg-gradient-to-r from-gray-900 to-gray-800 border-b border-gray-700 sticky top-0 z-50 backdrop-blur-sm bg-opacity-95">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16">
                    {/* Logo/Brand Section */}
                    <div className="flex items-center space-x-3">
                        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg">
                            <Zap className="w-6 h-6 text-white" strokeWidth={2.5} />
                        </div>
                        <div>
                            <h1 className="text-xl font-bold text-white tracking-tight">
                                Auto-Expertise AI
                            </h1>
                            <p className="text-xs text-gray-400 font-medium">
                                Traitement intelligent des documents
                            </p>
                        </div>
                    </div>

                    {/* Navigation Items */}
                    <div className="flex items-center space-x-1">
                        {navItems.map((item) => {
                            const Icon = item.icon;
                            const isActive = location.pathname === item.path;
                            
                            return (
                                <Link
                                    key={item.path}
                                    to={item.path}
                                    className={`group relative flex items-center px-4 py-3 rounded-lg text-sm font-medium transition-all duration-200 ease-out ${
                                        isActive
                                            ? "text-white bg-gradient-to-r from-blue-600 to-blue-700 shadow-lg shadow-blue-500/20"
                                            : "text-gray-300 hover:text-white hover:bg-gray-800/70"
                                    }`}
                                >
                                    {/* Active indicator line */}
                                    {isActive && (
                                        <div className="absolute -bottom-[17px] left-0 right-0 h-0.5 bg-gradient-to-r from-blue-400 to-blue-500 rounded-t-full"></div>
                                    )}
                                    
                                    {/* Icon with subtle animation */}
                                    <div className={`relative mr-3 ${
                                        isActive 
                                            ? "text-white" 
                                            : "text-gray-400 group-hover:text-blue-400"
                                    }`}>
                                        <Icon 
                                            className="w-4.5 h-4.5 transition-transform group-hover:scale-110" 
                                            strokeWidth={isActive ? 2.5 : 2}
                                        />
                                    </div>
                                    
                                    {/* Text with slight animation */}
                                    <span className={`transition-all duration-200 ${
                                        isActive 
                                            ? "font-semibold" 
                                            : "font-medium group-hover:translate-x-0.5"
                                    }`}>
                                        {item.name}
                                    </span>
                                    
                                    {/* Subtle hover effect */}
                                    {!isActive && (
                                        <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-blue-500/0 via-blue-500/0 to-blue-500/0 group-hover:from-blue-500/5 group-hover:via-blue-500/3 group-hover:to-blue-500/0 transition-all duration-300"></div>
                                    )}
                                </Link>
                            );
                        })}
                    </div>

                    {/* Optional: User/Profile section placeholder */}
                    <div className="hidden md:block">
                        <div className="ml-4 flex items-center">
                            <div className="h-8 w-8 rounded-full bg-gradient-to-br from-gray-700 to-gray-800 border border-gray-600 flex items-center justify-center">
                                <span className="text-xs font-semibold text-gray-300">AE</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}